module.exports = __webpack_public_path__ + "img/blog6.6bce83d2.jpg";